import React from 'react'
import { Route } from 'react-router-dom'
import MyProfile from './MyProfile'

import { myProfileRoot } from "../../../constants/routePaths"

const MyProfileRoute = [
  <Route
    key="MyProfile"
    exact path={myProfileRoot}
    component={MyProfile}
  />,
];

export default MyProfileRoute